var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" map "),_c('div',{attrs:{"id":"map"}},[_c('canvas',{staticStyle:{"height":"200px","width":"200px"},attrs:{"id":"can"}})])])}]

export { render, staticRenderFns }